import React from 'react';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import {useDispatch, useSelector} from 'react-redux';
import {setGetListPaymentSystem} from '../../store/thunk/setGetListPaymentSystem';
import TemplatePage from '../../../components/templatePage';
import PaymentItem from '../../components/paymentItem';
import DialogPayment from '../../components/dialog';

const PaymentList = () => {
    const dispatch = useDispatch();
    const [openModal, setOpenModal] = React.useState(false)

    React.useEffect(() => {
        dispatch(setGetListPaymentSystem({
            search: ''
        }))
    }, [])
    
    const list = useSelector(state => state.paymentMobile.list);

    return (
        <TemplatePage
            title="Платежные системы"
        >
            {
                list.map((item) => <PaymentItem item={item}/>)
            }
            <div style={{position: 'absolute', bottom: 20, right: 20}}>
               
                <Fab color="primary" aria-label="add" style={{width: 100, height: 100}} onClick={() => setOpenModal(true)}>
                   <AddIcon /> 
                </Fab>
            </div> 
            <DialogPayment openModal={openModal} setOpenModal={setOpenModal}/>
        </TemplatePage>
    )
}

export default PaymentList;